import * as XLSX from "xlsx";
import {
  formatDateDDMMYYYY,
  splitVietnameseName,
} from "../../../utils/formatUtils";

const formatGenderLabel = (raw) => {
  const g = String(raw || "").trim().toLowerCase();
  if (g === "male" || g === "nam") return "Nam";
  if (g === "female" || g === "nữ" || g === "nu") return "Nữ";
  return "—";
};

/** Xuất danh sách học viên của lớp ra file Excel. */
export function exportClassStudentsToExcel(classInfo, students = []) {
  if (!students.length) {
    return { ok: false, message: "Lớp chưa có học viên để tải danh sách." };
  }

  const sortedForExport = [...students].sort((a, b) => {
    const an = splitVietnameseName(a.full_name);
    const bn = splitVietnameseName(b.full_name);
    const byTen = an.ten.localeCompare(bn.ten, "vi", { sensitivity: "base" });
    if (byTen !== 0) return byTen;
    return an.ho.localeCompare(bn.ho, "vi", { sensitivity: "base" });
  });

  const rows = [
    [
      "Mã học sinh",
      "Họ",
      "Tên",
      "Ngày sinh",
      "Giới tính",
      "SĐT",
      "Email",
      "Địa chỉ",
      "Tên ba/mẹ",
      "SĐT ba/mẹ",
    ],
    ...sortedForExport.map((s) => {
      const { ho, ten } = splitVietnameseName(s.full_name);
      return [
        s.student_code || "",
        ho,
        ten,
        s.dob ? formatDateDDMMYYYY(s.dob) : "",
        formatGenderLabel(s.gender),
        s.phone || "",
        s.email || "",
        s.address || "",
        s.parent_name || "",
        s.parent_phone || "",
      ];
    }),
  ];

  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Danh sach hoc vien");
  XLSX.writeFile(wb, `ds_hoc_vien_${classInfo?.code || classInfo?.id || "lop"}.xlsx`);
  return { ok: true };
}
